module.exports = __webpack_public_path__ + "static/media/WU_FORM_compare.7c126b9e.svg";